export default "__VITE_ASSET__bd1772d2__"